import React from 'react';
import {
  SideNavCategory,
  SideNavColorSchemeProps,
  SideNavItemSelectEvent,
} from '../index';
import StyledCategoriesPanel from './StyledCategoriesPanel';
import CategorySection from '../category-section/CategorySection';
import { LoadingSkeleton } from '../..';

interface CategoriesPanelProps extends SideNavColorSchemeProps {
  categories: Array<SideNavCategory>;
  isSearching: boolean;
  onItemSelect?: (e: SideNavItemSelectEvent) => void;
  selectedItem?: SideNavCategory;
  isLoading?: boolean;
}

function CategoriesPanel({
  categories,
  isSearching,
  colorScheme,
  onItemSelect,
  selectedItem,
  isLoading,
}: CategoriesPanelProps): JSX.Element {
  return (
    <StyledCategoriesPanel colorScheme={colorScheme} overFlowX="hidden">
      {!isLoading ? (
        categories.map((category) => (
          <CategorySection
            colorScheme={colorScheme}
            key={category.key}
            category={category}
            selectedItem={selectedItem}
            onItemSelect={onItemSelect}
            isSearching={isSearching}
          />
        ))
      ) : (
        <LoadingSkeleton name="list" />
      )}
    </StyledCategoriesPanel>
  );
}

export default CategoriesPanel;
